import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import Login from './pages/dashboard/Login';
import Dashboard from './pages/dashboard/Dashboard';
import DashboardV2 from './pages/dashboard/Dashboardv2';
import DashboardV3 from './pages/dashboard/Dashboardv3';
import CustomDashboard from './pages/dashboard/CustomDashboard';
import TicketDashboard from './pages/dashboard/TicketDashboard';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from "./components/Header";
import ProtectedRoute from './components/ProtectedRoute';
import ViewDetails from './pages/dashboard/ViewDetails';
import Home from './pages/Home';
import CategoryDashboard from './pages/dashboard/CategoryDashboard';
//import logo from "../../assets/logo.png";


export function addCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const App = () => {
  const location = useLocation();
  const hideHeaderOn = ["/v1", "/v2", "/v3","/login"];
  const excelUrl = process.env.REACT_APP_EXCEL_URL;
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    title: "Dashboard",
    subtitle: "Analysis",
    logo: "logo.png",
    cards: [
      { title: "New Booked In Today", value: "15", subvalue: "£2,555" },
      { title: "Needs Quoting", value: "3", subvalue: "£8,555" },
      { title: "Invoiced", value: "17", subvalue: "£3,555" },
      { title: "Total Refunds This Month", value: "0", subvalue: "£0" },
      { title: "Waiting On Customer", value: "13", subvalue: "£8,555" },
      { title: "Engineer completed", value: "5" ?? 0, subvalue: "£2,555" },
      { title: "Rework Booked In Today", value: "0" },
      // { title: "Pending Estimates", value: "5", subvalue: "£1,620" },
      { title: "Awaiting Payment", value: "19", subvalue: "£8,555" },
      { title: "Awaiting Collection", value: "5", subvalue: "£2,555" },
      { title: "Waiting for Parts", value: "25", subvalue: "£8,555" },
      { title: "Quoted awaiting reply", value: "7" ?? 0, subvalue: "£2,555" },
      { title: "Total in Department", value: "31", subvalue: "£3,555" },
    ],
    progressCards: [
      { title: "Daily", value: 0, min: 0, max: 6500 },
      { title: "Monthly", value: 0, min: 0, max: 130000 },
      // { title: "Yearly", value: 0, min: 0, max: 3600000 },
    ]
  });
  const [openTickets, setOpenTickets] = useState({ count: 0, value: 0 });


  const [performanceData, setPerformanceData] = useState([
    {
      name: 'Nilesh',
      tickets: 1,
      reworks: 1,
      reworkPercent: '100%',
      NFF: 0,
      BR: 0,
      NS: 0,
      SJ: 0,
    },
    {
      name: 'Khalid',
      tickets: 20,
      reworks: 2,
      reworkPercent: '10%',
      NFF: 0,
      BR: 0,
      NS: 0,
      SJ: 18,
    },
    {
      name: 'Rakesh',
      tickets: 24,
      reworks: 3,
      reworkPercent: '12.5%',
      NFF: 0,
      BR: 0,
      NS: 0,
      SJ: 21,
    },
    {
      name: 'Kalpesh',
      tickets: 8,
      reworks: 5,
      reworkPercent: '62%',
      NFF: 0,
      BR: 0,
      NS: 0,
      SJ: 3,
    },
    {
      name: 'Ashok',
      tickets: 9,
      reworks: 1,
      reworkPercent: '11.11%',
      NFF: 0,
      BR: 0,
      NS: 0,
      SJ: 8,
    },
    {
      name: 'Priyesh',
      tickets: 15,
      reworks: 1,
      reworkPercent: '6.67%',
      NFF: 0,
      BR: 0,
      NS: 0,
      SJ: 14,
    },
    {
      name: 'Nishil',
      tickets: 17,
      reworks: 2,
      reworkPercent: '6.67%',
      NFF: 0,
      BR: 0,
      NS: 0,
      SJ: 14,
    },
    {
      name: 'Priyanshu',
      tickets: 9,
      reworks: 4,
      reworkPercent: '44.44%',
      NFF: 0,
      BR: 0,
      NS: 0,
      SJ: 5,
    },
    {
      name: 'Shafiq',
      tickets: 8,
      reworks: 4,
      reworkPercent: '50%',
      NFF: 0,
      BR: 0,
      NS: 0,
      SJ: 4,
    },
    {
      name: 'John',
      tickets: 5,
      reworks: 0,
      reworkPercent: '0%',
      NFF: 0,
      BR: 0,
      NS: 0,
      SJ: 5,
    },
  ])

  const [summaryData, setSummaryDataData] = useState([
    { label: "Current Job's(NEW)", value: 0 },
    { label: "Job's Completed This Month (NEW)", value: 0 },
    { label: 'Rework % This Month', value: 0 },
    { label: 'Not Allocated', value: 0 },
    { label: "Current Job's (Rework)", value: 0 },
    { label: "Job's Completed This Month(Rework)", value: 0 },
    { label: 'Total Refund This Month', value: 0 }
  ]);

  const [currentStats, setCurrentStats] = useState([
    { title: "TODAY", value: "12 JOBS", subvalue: "£2,345" },
    { title: "YESTERDAY", value: "9 JOBS", subvalue: "£1,876" },
    { title: "THIS WEEK", value: "45 JOBS", subvalue: "£8,210" },
    { title: "LAST WEEK", value: "38 JOBS", subvalue: "£7,540" }
  ]);

  const [categoryData, setCategoryData] = useState([
    { label: "ABS Pump Repair", value: 0 },
    { label: "Airbag Reset", value: 0 },
    { label: "BSI Repair", value: 0 },
    { label: "Climate Control Unit Repair", value: 0 },
    { label: "Diesel Injection Pump Repair", value: 0 },
    { label: "ECU Repair", value: 0 },
    { label: "ECU Tuning", value: 0 },
    { label: "EIS/ESL Repair", value: 0 },
    { label: "FRM Repair", value: 0 },
    { label: "Gear Lever Repair", value: 0 },
    { label: "Immobiliser Removing", value: 0 },
    { label: "Immobiliser Repair", value: 0 },
    { label: "Instrument Cluster Repair", value: 0 },
    { label: "Power Steering Repair", value: 0 },
    { label: "Radio CD Navigation Repair", value: 0 },
    { label: "Remote Repair", value: 0 },
    { label: "TCU Repair", value: 0 },
    { label: "Turbo Actuator Repair", value: 0 },
  ]);


  const [financialData, setFinancialData] = useState([
    {
      "id": 1,
      "Period": "Yesterday",
      "Value": 4000,
      "Target": 5000,
      "Completed": 80,
      "Color": "#EF4444"
    },
    {
      "id": 2,
      "Period": "This Week",
      "Value": 8500,
      "Target": 23800,
      "Completed": 35.71,
      "Color": "#3B82F6"
    },
    {
      "id": 3,
      "Period": "This Month",
      "Value": 25000,
      "Target": 150000,
      "Completed": 16.67,
      "Color": "#FBBF24",
      "Month to Date": 55215,
      "Projected Month": 96626,
      "Variance": -43374
    },
    {
      "id": 4,
      "Period": "This Year",
      "Value": 1000000,
      "Target": 1200000,
      "Completed": 83.33,
      "Color": "#10B981",
      "Projected Month": 96626,
      "Variance": -43374
    }
  ]);


  const fetchTicketCount = async () => {
    try {

      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/dashboard/tickets/count`);

      if (response.data.length > 0) {

        const data = response.data[0];
        //console.log("fetchTicketCount", data);

        setDashboardData((prevData) => ({
          ...prevData,
          cards: [
            { title: "New Booked In Today", value: data?.tickets_new_count ?? 0, subvalue: data?.tickets_new_retail_price ? `Potential Value: ${addCommas(`£${data.tickets_new_retail_price.toFixed(0)}`)}` : "Potential Value: £0" },
            { title: "Needs Quoting", value: data?.tickets_needs_quoting_count, subvalue: data?.tickets_needs_quoting_retail_price ? `Potential Value: ${addCommas(`£${data.tickets_needs_quoting_retail_price.toFixed(0)}`)}` : "Potential Value: £0" },
            { title: "Invoiced", value: data.invoice_count_daily ?? 0, subvalue: data?.daily_subtotal ? `${addCommas(`£${data.daily_subtotal.toFixed(0)}`)}` : "£0" },
            { title: "Total Refunds This Month", value: data.totalRefundCount, subvalue: data?.totalRefund ? `${addCommas(`£${Math.abs(data.totalRefund.toFixed(0))}`)}` : "£0" },
            { title: "Waiting On Customer", value: data.tickets_waiting_customer_count ?? 0, subvalue: data?.tickets_waiting_customer_retail_price ? `Potential Value: ${addCommas(`£${data.tickets_waiting_customer_retail_price.toFixed(0)}`)}` : "Potential Value: £0" },
            { title: "Engineer completed", value: data.tickets_eng_completed_count ?? 0, subvalue: data?.tickets_eng_completed_retail_price ? `Potential Value: ${addCommas(`£${data.tickets_eng_completed_retail_price.toFixed(0)}`)}` : "Potential Value: £0" },
            { title: "Rework Booked In Today", value: data.tickets_new_rework_count ?? 0 },
            // { title: "Pending Estimates", value: 0, subvalue: "Potential Value: £0" },
            { title: "Awaiting Payment", value: data.tickets_awaiting_payment_count ?? 0, subvalue: data?.tickets_awaiting_payment_retail_price ? `Potential Value: ${addCommas(`£${data.tickets_awaiting_payment_retail_price.toFixed(0)}`)}` : "Potential Value: £0" },
            { title: "Awaiting Collection", value: data.tickets_awaiting_collection_count ?? 0, subvalue: data?.tickets_awaiting_collection_retail_price ? `Potential Value: ${addCommas(`£${data.tickets_awaiting_collection_retail_price.toFixed(0)}`)}` : "Potential Value: £0" },
            { title: "Waiting for Parts", value: data.tickets_waiting_parts_count ?? 0, subvalue: data?.tickets_waiting_parts_retail_price ? `Potential Value: ${addCommas(`£${data.tickets_waiting_parts_retail_price.toFixed(0)}`)}` : "Potential Value: £0" },
            { title: "Quoted awaiting reply", value: data.tickets_quoted_count ?? 0, subvalue: data?.tickets_quoted_retail_price ? `Potential Value: ${addCommas(`£${data.tickets_quoted_retail_price.toFixed(0)}`)}` : "Potential Value: £0" },
            { title: "Total in Department", value: data.tickets_department_count, subvalue: data?.tickets_department_retail_price ? `Potential Value: ${addCommas(`£${data.tickets_department_retail_price.toFixed(0)}`)}` : "Potential Value: £0" },
          ],
          progressCards: [
            { id : 1, value: data.today_total_amount ?? 0 },
            { id : 2, value: data.weekly_total_amount ?? 0},
            { id : 3, value: data.monthly_total_amount ?? 0 },
            { id : 4, value: data.yearly_total_amount ?? 0},
          ],
        }));

        setSummaryDataData([
          { label: "Current Job's(NEW)", value: data.tickets_in_eng_dep_new, subvalue: data.tickets_in_eng_dep_new_retail_price ? `Potential Value:  ${addCommas(`£${data.tickets_in_eng_dep_new_retail_price.toFixed(0)}`)}` : "Potential Value: £0" },
          { label: "Job's Completed This Month (NEW)", value: data.jobs_per_month },
          {
            label: 'Rework % This Month',
            value: ((data.jobs_rework_per_month / data.jobs_per_month) * 100).toFixed(0) + '%'
          },
          { label: 'Not Allocated', value: 0 },
          { label: "Current Job's (Rework)", value: data.tickets_in_eng_dep_rework },
          { label: "Job's Completed This Month(Rework)", value: data.jobs_rework_per_month },
          { label: 'Total Refund This Month', value: data?.totalRefund ? addCommas(`£${Math.abs(data.totalRefund.toFixed(0))}`) : "£0" }
        ]);

        setCurrentStats([
          { title: "TODAY", value: `${data.today_total_records} JOBS`, subvalue: (() => { const amt = data.today_total_amount; return amt ? (amt * 0.8).toLocaleString('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }) : "£0"; })() },
          { title: "YESTERDAY", value: `${data.yesterday_total_records} JOBS`, subvalue: (() => { const amt = data.yesterday_total_amount; return amt ? (amt * 0.8).toLocaleString('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }) : "£0"; })() },
          { title: "THIS WEEK", value: `${data.weekly_total_records} JOBS`, subvalue: (() => { const amt = data.weekly_total_amount; return amt ? (amt * 0.8).toLocaleString('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }) : "£0"; })() },
          { title: "LAST WEEK", value: `${data.last_weekly_total_records} JOBS`, subvalue: (() => { const amt = data.last_weekly_total_amount; return amt ? (amt * 0.8).toLocaleString('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }) : "£0"; })() },
        ]);
        setOpenTickets({ count: data.total_tickets_count, value: data.total_tickets_retail_price ? addCommas(`£${data.total_tickets_retail_price.toFixed(0)}`) : "£0" });
      }


    } catch (error) {
      console.error(`Error fetching fetchTicketCount`, error);
    }
  };

  const fetchEngineerData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/dashboard/engineer/performance`);

      // console.log("fetchEngineerData", response.data);
      if (response.data.length > 0) {

        let transformedData = response.data.
          map((engineer) => {
            const reworkPercent =
              engineer.Total_Tickets > 0
                ? ((engineer.Rework_Tickets / engineer.Total_Tickets) * 100).toFixed(
                  2
                )
                : 0;

            return {
              name: engineer.Engineer_Name,
              tickets: engineer.Total_Tickets,
              reworks: engineer.Rework_Tickets,
              reworkPercent: reworkPercent,
              NFF: engineer.NFF_Tickets,
              BR: engineer.BR_Tickets,
              NS: engineer.Not_Successful_Tickets,
              SJ: engineer.Total_Tickets - (engineer.Rework_Tickets + engineer.BR_Tickets + engineer.Not_Successful_Tickets), // Assuming SJ is 'successful jobs'
            };
          }).sort((a, b) => Number(b.SJ) - Number(a.SJ));

        setPerformanceData(transformedData.filter((engineer) => engineer.name !== "Unknown"));
      }
    } catch (error) {
      console.error("Error fetching fetchEngineerData:", error);
    }
  };

  const fetchCategoryData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/dashboard/category/data`);
     //console.log("respose",response)

      setCategoryData(response.data.categories.sort((a, b) => b.value - a.value).filter((item) => item.count > 0))

    } catch (error) {
      console.error("Error fetching fetchEngineerData:", error);
    }
  };

  const fetchFinancialData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/dashboard/fetch-excel?url=${excelUrl}`);
      if (response.data.data.length > 0) {
        setFinancialData(response.data.data)
      }
    } catch (error) {
      console.error("Error fetching fetchEngineerData:", error);
    }
  };


  const fetchAllData = async () => {
    setLoading(true);
    try {
      await Promise.all([
        fetchTicketCount(),
        fetchEngineerData(),
        fetchCategoryData(),
        fetchFinancialData()
      ]);
    } catch (error) {
      console.error("Error fetching all data:", error);
    } finally {
      setLoading(false);
    }
  };


  const initialFetchRef = useRef(false);

  useEffect(() => {
    if (!initialFetchRef.current) {
      initialFetchRef.current = true;
      fetchAllData();
    }
    const dashboardInterval = setInterval(fetchAllData, 90000);
    return () => clearInterval(dashboardInterval);
  }, []);

  // return (
  //   <BrowserRouter>
  //   {/* Show Header on all pages except Login */}
  //    {location.pathname !== "/" && <Header />}
  //   {/* {window.location.pathname !== "/" && <Header />} */}
  //     <div>
  //       <Routes>
  //         <Route path="/login" element={<Login /*data={dashboardData} loading={loading} totalRefund={summaryData[5]} financialData={financialData} openTickets={openTickets}*/ />} />
  //         <Route path="/v1" element={<Dashboard data={dashboardData} loading={loading} totalRefund={summaryData[5]} financialData={financialData} openTickets={openTickets} />} />
  //         <Route path="/v2" element={<DashboardV2  data={dashboardData} summaryData={summaryData} performanceData={performanceData} loading={loading} categories={categoryData} currentStats={currentStats} financialData={financialData} openTickets={openTickets} />} />
  //         <Route path="/v3" element={<DashboardV3 data={dashboardData} summaryData={summaryData} performanceData={performanceData} loading={loading} categories={categoryData} currentStats={currentStats} financialData={financialData} openTickets={openTickets} />} />
  //       </Routes>
  //     </div>
  //   </BrowserRouter>
  // );

  return (
    <>
      {/* Show Header on all pages except Login */}
      {/* {location.pathname !== "/" && <Header />} */}



      {!hideHeaderOn.includes(location.pathname) && <Header />}


      <Routes>
        {/* <Route path="/" element={<Login />} /> */}
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/v1" element={<Dashboard data={dashboardData} loading={loading} totalRefund={summaryData[5]} financialData={financialData} openTickets={openTickets} />} />
        <Route path="/v2" element={<DashboardV2 data={dashboardData} summaryData={summaryData} performanceData={performanceData} loading={loading} categories={categoryData} currentStats={currentStats} financialData={financialData} openTickets={openTickets} />} />
        <Route path="/v3" element={<DashboardV3 data={dashboardData} summaryData={summaryData} performanceData={performanceData} loading={loading} categories={categoryData} currentStats={currentStats} financialData={financialData} openTickets={openTickets} />} />
        {/* <Route path="/v4" element={<CustomDashboard data={dashboardData} summaryData={summaryData} performanceData={performanceData} loading={loading} categories={categoryData} currentStats={currentStats} financialData={financialData} openTickets={openTickets} />} />
        <Route path="/v5" element={<TicketDashboard data={dashboardData} summaryData={summaryData} performanceData={performanceData} loading={loading} categories={categoryData} currentStats={currentStats} financialData={financialData} openTickets={openTickets} />} /> */}
        <Route
          path="/v4"
          element={
            <ProtectedRoute>
              <CustomDashboard
                // data={dashboardData}
                // summaryData={summaryData}
                // performanceData={performanceData}
                // loading={loading}
                // categories={categoryData}
                // currentStats={currentStats}
                // financialData={financialData}
                // openTickets={openTickets}
              />
            </ProtectedRoute>
          }
        />

        <Route
          path="/v5"
          element={
            <ProtectedRoute>
              <TicketDashboard
                data={dashboardData}
                summaryData={summaryData}
                performanceData={performanceData}
                loading={loading}
                categories={categoryData}
                currentStats={currentStats}
                financialData={financialData}
                openTickets={openTickets}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/v6"
          element={
            <ProtectedRoute>
            <CategoryDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/view-details" element={<ViewDetails />} />


      </Routes>
    </>
  );

};

export default App;